import { useNavigate } from "react-router-dom";

// styles and images
import "../project/Project.css";
import Download from "../../assets/download.svg";
import Delete from "../../assets/delete.svg";
// store
import { messageAndErrorStore, projectStore, userStore } from "../../store/Store";
import Dates from "../../components/Dates";
import { getFormattedDate } from "../../funcs/helperFuncs";
import { DownloadAccrual, getAccrualTotals } from "../../funcs/accruals/downloadAccrual";
import { useState } from "react";
import { getAccruals } from "../../funcs/accruals/getAccruals";

export default function AccrualsListRows() {
  // global
  const JwtToken = userStore((data) => data.JwtToken);
  const setAuthStatus = userStore((data) => data.setAuthStatus);
  const projectAccruals = projectStore((data) => data.projectAccruals);
  const setProjectAccruals = projectStore((data) => data.setProjectAccruals);
  const currentProject = projectStore((data) => data.currentProject);
  const projectLoads = projectStore((data) => data.projectLoads);
  const projectAssetLoads = projectStore((data) => data.projectAssetLoads);
  const toggleNewMessage = messageAndErrorStore(data => data.toggleNewMessage)
  
  
  const [pending, setPending] = useState(false)

  // local
  const navigate = useNavigate();

  
  
  const handleDownload = async (accrual) => { 
    const start = getFormattedDate(accrual.start_date).split("T");
    const end = getFormattedDate(accrual.end_date).split("T");
    
    const [accruedLoads, accruedAssetLoads] = getAccruals(
      projectLoads,
      projectAssetLoads,
      start[0],
      end[0],
    );

    const { freightTotals, sandTotals, err } = await getAccrualTotals(
      start[0],
      end[0],
      currentProject.project.id,
      JwtToken,
      setAuthStatus,
      navigate,
    );
    
    if (err) {
      toggleNewMessage("Something went wrong")
      setPending(false)
      return
    }
    const uploadError = await DownloadAccrual(
      accruedLoads,
      accruedAssetLoads,  
      accrual.accrual_name,
      currentProject.project.job_name,
      freightTotals,
      sandTotals,
    );

    if (uploadError) {
      toggleNewMessage("Could not Get Accrual");
    }

  };

  const handleDelete = (accrual) => {
    const controller = new AbortController();
    const headers = new Headers();
    headers.append("Authorization", "Bearer " + JwtToken);
    headers.append("Content-Type", "text/csv");
    const requestOptions = {
      method: "PATCH",
      headers,
    };
    const deleteOptions = {
      method: "DELETE",
      headers,
    }
    let accName = accrual.accrual_name.replace(/[/\\]/g, "-");
    let jobName = currentProject.project.job_name.replace(/[/\\]/g, "-");
    fetch(
      `${process.env.REACT_APP_BACKEND}/pc/delete-file/${jobName} - ${accName}.xlsx/project-accruals`,
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          if (response.status === 401) {
            setAuthStatus(false);
            navigate("/login");
          } else {
            toggleNewMessage("Could not delete accrual");
          }
        } else {
          toggleNewMessage(null, "Accrual Deleted");
        }
      })
      .then(
        fetch(
          `${process.env.REACT_APP_BACKEND}/pc/project-accural/delete/${accrual.id}`,
          deleteOptions
        )
          .then((res) => {
            if (!res.ok) {
              if (res.status === 401) {
                setAuthStatus(false);
                navigate("/login");
                return;
              } else {
                toggleNewMessage("Could not delete accrual");
                return;
              }
            } else {
              return res.json();
            }
          })
          .then((data) => {
            setProjectAccruals(data);
          })
      )
      .catch((_) => {
        toggleNewMessage("Something went wrong");
        return;
      });
    return () => controller.abort();
  };

  return projectAccruals ? (
    <tbody>
      {projectAccruals.map((acc, idx) => (
        <tr key={idx}>
          <td>{acc.accrual_name}</td>
          <Dates d={acc.start_date} />
          <Dates d={acc.end_date} />
          <td>{acc.total_loads}</td>
          <td>
            {parseFloat(acc.freight_weight_tons.toFixed(2)).toLocaleString(
              "en-US"
            )}
          </td>
          <td>
            {parseFloat(
              acc.freight_weight_not_billed.toFixed(2)
            ).toLocaleString("en-US")}
          </td>
          <td>
            {parseFloat(
              acc.freight_weight_not_received.toFixed(2)
            ).toLocaleString("en-US")}
          </td>
          <td>
            {parseFloat(acc.sand_weight_tons.toFixed(2)).toLocaleString(
              "en-US"
            )}
          </td>
          <td>
            {parseFloat(acc.sand_weight_not_billed.toFixed(2)).toLocaleString(
              "en-US"
            )}
          </td>
          <td>
            {parseFloat(acc.sand_weight_not_received.toFixed(2)).toLocaleString(
              "en-US"
            )}
          </td>
          <td>
            ${parseFloat(acc.freight_rev.toFixed(2)).toLocaleString("en-US")}
          </td>
          <td>
            $
            {parseFloat(acc.freight_not_billed.toFixed(2)).toLocaleString(
              "en-US"
            )}
          </td>
          <td>
            ${parseFloat(acc.freight_cost.toFixed(2)).toLocaleString("en-US")}
          </td>
          <td>
            $
            {parseFloat(acc.freight_not_received.toFixed(2)).toLocaleString(
              "en-US"
            )}
          </td>
          <td>
            ${parseFloat(acc.sand_rev.toFixed(2)).toLocaleString("en-US")}
          </td>
          <td>
            $
            {parseFloat(acc.sand_not_billed.toFixed(2)).toLocaleString("en-US")}
          </td>
          <td>
            ${parseFloat(acc.sand_cost.toFixed(2)).toLocaleString("en-US")}
          </td>
          <td>
            $
            {parseFloat(acc.sand_not_received.toFixed(2)).toLocaleString(
              "en-US"
            )}
          </td>
          <td className="action">
            {!pending && <div className="container">
              <img
                className="invoice-action"
                src={Download}
                alt="download"
                onClick={() => handleDownload(acc)}
              />
              <img
                className="invoice-action"
                src={Delete}
                alt="delete"
                onClick={() => handleDelete(acc)}
              />
            </div>}
          </td>
        </tr>
      ))}
    </tbody>
  ) : (
    <p>No project accruals have been added</p>
  );
}
